import { useMemo } from 'react';
import { useGetAllCreancesQuery } from 'actions/creances/queries';
import { useUpdateCreanceMutation } from 'actions/creances/mutations';
import { toast } from 'react-toastify';

const useCreancesData = (dossierId) => {
  const { data: creancesResponse, isLoading, isFetching, refetch } = useGetAllCreancesQuery({
    dossier_id: dossierId,
  });

  const [updateCreance] = useUpdateCreanceMutation();

  const { updatedCreances, count, totalCreances } = useMemo(() => {
    if (!creancesResponse) {
      return { updatedCreances: [], count: 0, totalCreances: 0 };
    }

    const creancesData = Array.isArray(creancesResponse)
      ? creancesResponse
      : creancesResponse?.data;

    if (creancesData && Array.isArray(creancesData)) {
      return {
        updatedCreances: creancesData,
        count: creancesResponse?.count || creancesData.length,
        totalCreances: creancesResponse?.totalCreances || 0,
      };
    }

    return { updatedCreances: [], count: 0, totalCreances: 0 };
  }, [creancesResponse]);

  const handleUpdateCreance = async (creanceId, updateData) => {
    try {
      await updateCreance({ id: creanceId, ...updateData }).unwrap();
      refetch();
    } catch (error) {
      toast.error(
        `Erreur lors de la mise à jour: ${error.data?.error || error.message}`
      );
      console.error(error);
    }
  };

  return {
    updatedCreances,
    handleUpdateCreance,
    count,
    totalCreances,
    isLoading: isLoading || (isFetching && !creancesResponse),
    refetch,
  };
};

export default useCreancesData;

